precision highp float;

uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;
uniform float uTime;
uniform float uDisplaceFactor;
uniform vec3 uTranslate;
uniform float uScaleFactor;

attribute vec3 position;
attribute vec2 uv;

varying vec2 vUv;
varying float vPos;

mat4 scale(float c) {
	return mat4(c, 0, 0, 0,
    0, c, 0, 0,
    0, 0, c, 0,
    0, 0, 0, 1);
}

mat4 translate(vec3 d) {
	return mat4(
    1, 0, 0, d.x,
    0, 1, 0, d.y,
    0, 0, 1, d.z,
    0, 0, 0, 1
  );
}

mat4 rotationMatrix(vec3 axis, float angle) {
  axis = normalize(axis);
  float s = sin(angle);
  float c = cos(angle);
  float oc = 1.0 - c;
  return mat4(oc * axis.x * axis.x + c, oc * axis.x * axis.y - axis.z * s, oc * axis.z * axis.x + axis.y * s, 0.0,
  oc * axis.x * axis.y + axis.z * s, oc * axis.y * axis.y + c, oc * axis.y * axis.z - axis.x * s, 0.0,
  oc * axis.z * axis.x - axis.y * s, oc * axis.y * axis.z + axis.x * s, oc * axis.z * axis.z + c, 0.0,
  0.0, 0.0, 0.0, 1.0);
}

void main() {
  vUv = uv;

  vec4 pos = vec4(position, 1.0);

  if (uDisplaceFactor > 0.) {
    pos.z += sin(uv.x * 6.0 + uv.y * 0.7 + uDisplaceFactor * 0.0001);
    vPos = pos.z;
  }


  gl_Position = projectionMatrix * modelViewMatrix * (pos * scale(uScaleFactor) * translate(uTranslate));
}